import task from 'helpers/task'
import inject from 'helpers/inject'

import ApiService from 'services/api'

export default task(async function(userId, { oldPassword, newPassword, newPasswordConfirm }) {
  const api = inject(ApiService)
  await api.request({
    url: `/api/accounts/${userId}/change_password`,
    method: 'PATCH',
    data: { oldPassword, newPassword, newPasswordConfirm }
  })
  return true
}, {
  defaultValue: false
})



// WEBPACK FOOTER //
// ./src/tasks/changePassword.js